export default "__VITE_ASSET__B1A1kq_H__"